module.exports = __webpack_public_path__ + "static/img/logo.5587f58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 4Uwr
// module chunks = 5